<div [dir]="languageService.getCurrentLang() === 'ar' ? 'rtl' : 'ltr'">

<router-outlet></router-outlet>

</div>